import classNames from 'classnames';
import React from 'react';
import fr from 'facet-rest';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from 'Components/UI/Typography';
import HelpIcon from '@material-ui/icons/Help';
import useUserContext from 'Context/UserContext';

function InvestmentsRoot({ classes, ...rest }) {
  const { userResource } = useUserContext();

  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'Investments',
  });

  const src = userResource
    .relationship(fr.relationships.investmentsPerformance.name)
    .link('related')
    .url();

  return (
    <div className={classNames(classes.root)} {...rootNodeProps} {...rest}>
      <iframe
        title="Investments"
        id="investments-performance"
        src={src}
      />
      <Accordion defaultExpanded elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1bh-content"
        >
          <Typography className={classes.heading}>Help</Typography>
          &nbsp;
          <HelpIcon color="primary" fontSize="small" />
        </AccordionSummary>
        <AccordionDetails>
          <div>
            <p>To review preformance data on the household:</p>
            <ol>
              <li>
                {'Click the '}
                <span className={classes.orionLike}>
                  <i className="fa fa-user-plus" />
                </span>
                {
                  " and search the client's name (you will not be able to search by Facet's HHID)"
                }
              </li>
              <li>
                {'Click the "Performance" in the top navigation bar.'}
              </li>
              <li>
                {'If you only want to look at managed accounts, click the '}
                <span className={classes.orionLike}>
                  <i className="fa fa-cog" />
                </span>
                {' icon and select "Managed Accounts"'}
              </li>
              <li>
                {'If you click the '}
                <span className={classes.orionLike}>
                  <i className="fa fa-ellipsis-h" />
                </span>
                {' icon, you can customize perfomance for all your households.'}
              </li>
            </ol>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}

export default withStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    '& iframe': {
      flexGrow: 1,
    },
  },
  orionLike: {
    color: '#6b7280',
  },
}))(InvestmentsRoot);
